<template>
  <div
    :class="[
      'peer-view-wrapper',
      { 'order-first': orderFirst},
      { 'hiding': !isDisplay },
      (shareState ? 'sharer' : speakerState ? 'active-speaker' : '')
    ]"
    :style="{ backgroundImage: 'url(' + require('@/assets/images/user.png') + ')' }">
    <div class="peer-view-content">
      <span :class="['font-weight-bold shared-state', { 'd-none': !shareState }]">画面共有中</span>
      <span class="font-weight-bold display-name">{{ displayName }}</span>
      <video :srcObject.prop="videoStream" autoplay muted playsinline class="peer-video"></video>
      <audio :srcObject.prop="audioStream" autoplay></audio>
      <mdb-tooltip
        trigger="hover"
        material
        sm
      >
       <span v-if="myself && !device.isMobile" slot="tip">マイク{{ micState ? 'オフ' : 'オン' }}</span>
        <mdb-icon
          slot="reference"
          size="lg"
          :icon="micState || audioState ? 'microphone' : 'microphone-slash'"
          :class="['mic-state', {
            'text-danger': !micState && !audioState,
            'animated flash slower infinite': speakerState,
            'clickable': $listeners.toggleMic
          }]"
          @click.native="toggleMic"
        />
      </mdb-tooltip>
      <div v-if="myself" class="volume-container">
        <div class="volume-border volume-border-top" :style="{ height: `${calcMicVolume}%` }"/>
        <div class="volume-border volume-border-bottom" :style="{ height: `${calcMicVolume}%` }"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PeerView',
  props: {
    shareState: Boolean,
    speakerState: Boolean,
    micState: Boolean, // 自身のみ使用
    micVolume: Number, // 自身のみ使用(0 ~ 10)
    videoStream: MediaStream,
    audioStream: MediaStream,
    displayName: String,
    myself: Boolean,
    isDisplay: Boolean,
    viewMode: Number,
    device: Object
  },
  computed: {
    audioState: function() {
      return !this.myself && this.audioStream
    },
    orderFirst: function() {
      return this.shareState && this.viewMode != 0
    },
    calcMicVolume: function() {
      return this.micVolume * 10 / 2
    }
  },
  methods: {
    toggleMic: function() {
      if (this.$listeners.toggleMic) {
        this.$emit('toggleMic')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/_mediaquery.scss";

.peer-view-wrapper {
  order: 2;
  margin: 0.2rem;
  position: relative;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  box-shadow: 0 5px 12px 2px rgba(17,17,17,0.5);
  background-color: $secondary-color;

  &:before {
    content:"";
    display: block;
    padding-top: 66%;
  }

  .peer-view-content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  &.sharer {
    border: 2px solid $default-border-color !important;
  }

  &.active-speaker {
    border: 2px solid $default-border-color !important;
  }

  &.order-first {
    order: -1;
  }

  .shared-state {
    position: absolute;
    top: 5px;
    left: 10px;
    z-index: 1;
    color: white;
    text-shadow: 1px 1px 2px $secondary-color;
  }

  .display-name {
    position: absolute;
    bottom: 0.5rem;
    left: 0.5rem;
    width: 70%;
    z-index: 1;
    color: white;
    text-shadow: 1px 1px 2px $secondary-color;
    overflow: hidden;
    text-overflow: ellipsis;

    font-size: 0.9rem;

    @include mq(sm) {
      bottom: 0.3rem;
      right: 0.3rem;
    }
  }

  .mic-state {
    position: absolute;
    bottom: 0.8rem;
    right: 0.8rem;
    z-index: 1;
    text-shadow: 1px 1px 2px $secondary-color;

    @include mq(sm) {
      bottom: 0.5rem;
      right: 0.5rem;
    }
  }

  .peer-video {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &.hiding {
    visibility: hidden;
  }

  .volume-container {
    position: absolute;
    top: 0;
    right: 6px;
    height: 100%;
    width: 4px;

    .volume-border {
      border-radius: 0 0 1rem 1rem / 0 0 1rem 1rem;
      background: $primary-color;
      opacity: 0.5;
      position: absolute;
      top: 50%;
      width: 100%;
      transition: height 0.5s;

      &.volume-border-top {
        transform: rotate(180deg);
        transform-origin: top center;
      }
    }
  }
}
</style>
